'use strict';
var angular = require('angular');

var inputSelectCtrl = ['$timeout', function ($timeout) {
    var _this = this;
    this.focusInput = false;
    this.focusSelect = false;
    this.showSuggestionsDialog = false;
    this.suggestions = [];
    this.selectedSuggestion = null;

    if (!this.inputvalue) { this.inputvalue = null; }
    this.selectedName = "";
    if (this.inputvalue) {
        let selectedOption = this.optionlist.find(option => option.value === this.inputvalue);
        if (selectedOption) {
            this.selectedName = selectedOption.name;
        }
    }

    this.search = function() {
        if (!_this.selectedName) {
            _this.suggestions = _this.optionlist;
            _this.showSuggestionsDialog = true;
            return;
        }
        _this.showSuggestionsDialog = true;

        _this.suggestions = _this.optionlist.filter(function(suggestion) {
            return suggestion.name.toLowerCase().includes(_this.selectedName.toLowerCase());
        });
    };

    // Seleccionar una sugerencia
    this.selectSuggestion = function() {
        if (!_this.selectedSuggestion) return;

        _this.selectedName = _this.selectedSuggestion.name; // Muestra el name
        _this.inputvalue = _this.selectedSuggestion.value; // Guarda el value y lo pasa al padre
        _this.suggestions = [];
    };

    // Manejar la tecla Enter
    this.enter = function(event) {
        if (event.keyCode === 13) { // 'Enter' key
            this.selectSuggestion();
            event.preventDefault(); // Prevents the browser's default behavior
            event.stopPropagation(); // Stops the event's propagation to prevent it from affecting other parts of the application.
        }
    };

    // The $timeout function allows select to execute "selectSuggestion" function, before hidding the select dialog
    this.onBlur = function() {    
        $timeout(() => {
            if (!_this.focusSelect) {
                _this.showSuggestionsDialog = false;
                _this.suggestions = [];
            }
            _this.focusInput = false;
            _this.focusSelect = false;
        }, 100);
    };

    // 'search' icon 
    this.searchIcon = function() {
        _this.search();
        document.getElementById('searchInput').focus();
    };

    // Clear input from 'x' icon 
    this.clearInput = function() {
        _this.selectedName = '';
        _this.inputvalue = null;
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            inputvalue: '=', // Enlace bidireccional con el padre
            optionlist: '='
        },
        controller: inputSelectCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/inputSelectDirective.html'
    };
};
